import { render, staticRenderFns } from "./automatic-upgrade-time.vue?vue&type=template&id=28a92521&scoped=true"
import script from "./automatic-upgrade-time.vue?vue&type=script&lang=js"
export * from "./automatic-upgrade-time.vue?vue&type=script&lang=js"
import style0 from "./automatic-upgrade-time.vue?vue&type=style&index=0&id=28a92521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a92521",
  null
  
)

export default component.exports